import React, { useContext, useState } from 'react'
import { AppContext } from '../App'

const Navbar = () => {
    let user = JSON.parse(localStorage.getItem('authResult'))
        ? JSON.parse(localStorage.getItem('authResult'))
        : { role: '', fullName: '' }

    const { isTrue, toggleValue } = useContext(AppContext)
    return <></>
}

export default Navbar
